export default theme => ({
  generateButton: {
    position: 'fixed',
    bottom: theme.spacing.unit * 5,
    right: theme.spacing.unit * 5
  },
  searchInput: {
    marginBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing.unit * 2,
      marginRight: theme.spacing.unit * 2
    }
  }
})



// WEBPACK FOOTER //
// ./src/views/DataGenerator/Main/styles.js